module.exports = __webpack_public_path__ + "static/media/DiscoverPath.627a5391.svg";